import React from 'react';
import { connect } from 'react-redux';
import injectIntl, { intlShape } from 'common/injectIntl';
import { countrySelector } from 'selectors/appSelector';
import heroSelector from 'selectors/heroSelector';
import { placementPrefixSelector } from 'selectors/analyticsSelectors';
import scheduleModuleBucketsSelector from 'selectors/scheduleModuleBucketsSelector';
import { concatAll } from 'lib/util';
import { BucketStatus } from 'enums';
import ScheduleEventCard from './ScheduleEventCard';

const CONTENT_LIMIT = 4;

export const ScheduleModuleContainer = ({
    buckets,
    contentLimit = CONTENT_LIMIT,
    country,
    hero,
    placementPrefix,
    messages,
    intl: { formatMessage }
}) => {
    const headerLinkClass = 'icon-font-after icon-caret-right-solid-after';
    let classes = 'contentCollection contentCollection--watchSchedule sub-module';
    let headerTitle = formatMessage(messages['schedule.module.header.live']);    // should never actually use this default
    let schedPageHref = '/watch/schedule';
    let placement = placementPrefix; // nielsen placement

    const unSortedContents = concatAll(
        buckets.filter((bucket) => {
            const tags = bucket.tags || [];
            // render live or upcoming schedule module based on the hero
            if (hero && hero.type === 'video' && tags.indexOf(BucketStatus.WEB_LIVE) !== -1) {
                headerTitle = formatMessage(messages['schedule.module.header.live']);
                placement += 'top-live';
                classes += ' live';
                return true;
            } else if (hero && hero.type === 'event' && tags.indexOf(BucketStatus.WEB_UPCOMING) !== -1) {
                headerTitle = formatMessage(messages['schedule.module.header.upcoming']);
                placement += 'upcoming';
                schedPageHref += '?type=upcoming';
                return true;
            }
            return false;
        })
        .map((bucket) => bucket.contents || [])
    );

    const contents = unSortedContents
        .slice(0, contentLimit)
        .sort((contentA, contentB) => {
            const aDate = new Date(contentA.rawDate || contentA.time);
            const bDate = new Date(contentB.rawDate || contentB.time);
            return aDate.getTime() - bDate.getTime();
        });

    const cards = contents.map((content) =>
        <ScheduleEventCard key={`eventcard-${content.name}`} content={content} placement={placement} />
    );

    const moduleHeader = (country === 'us') ?
        <h1><a data-route="false" className={headerLinkClass} href={schedPageHref}>{headerTitle}</a></h1> :
        <h1><div data-route="false" className={headerLinkClass}>{headerTitle}</div></h1>;

    return (contents.length > 0) ? (
        <section className={classes}>
            <header>
                {moduleHeader}
            </header>
            {cards}
        </section>
    ) : null;
};

ScheduleModuleContainer.propTypes = {
    buckets: React.PropTypes.array,
    contentLimit: React.PropTypes.number,
    country: React.PropTypes.string,
    hero: React.PropTypes.object,
    placementPrefix: React.PropTypes.string,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    buckets: scheduleModuleBucketsSelector(state),
    hero: heroSelector(state),
    placementPrefix: placementPrefixSelector(state),
    country: countrySelector(state)
});

export default connect(mapStateToProps)(injectIntl(ScheduleModuleContainer));



// WEBPACK FOOTER //
// ./app/scheduleModule/ScheduleModuleContainer.js